module.exports = __webpack_public_path__ + "img/sPutA.2cb49fe4.svg";